import React, { useState, useEffect } from "react";
import {useNavigationParse} from "@arctheme-hooks/useNavigationParse";
import useHeaderMenuStore from "@src/stores/HeaderMenuStore";

export const HeaderMenu = ({ link_list, settings }) => {
    const [hoveredLink, setHoveredLink] = useState(null);
    const menuLinks = link_list[0].links;
    const {
        show_caret,
        header_font_type
    } = settings.section;

    useEffect(() => {
        window.addEventListener("megamenu-closed", handleMenuClose);

        if (hoveredLink !== null) {
            const event = new CustomEvent('megamenu-hover', {
                detail: { message: `header-${hoveredLink}` }
            });

            window.dispatchEvent(event);
        }

        return () => {
            setHoveredLink(null);
        };
    }, []);

    const handleMenuClose = () => {
        setHoveredLink(null);
    };

    return (
        <div className="header-links">
            <div className="block">
                <ul className="header-menu inline-flex">
                    {menuLinks.map((link, id) => {
                        const text = useNavigationParse(link.title);
                        const titleLowerCase = text.text.toLowerCase();
                        const dataId = titleLowerCase.replace(' ', '-');
                        const activeClass = link.active ? 'active' : 'inactive';
                        const hoverClass = hoveredLink === dataId ? 'hovered' : '';

                        return (
                            <li className={header_font_type} data-id={`header-${dataId}`} key={id}>
                                <a
                                    href={link.url}
                                    className={`${activeClass} ${hoverClass} menu-link`}
                                    onMouseEnter={() => setHoveredLink(dataId)}
                                >
                                    <span className={`inline-flex justify-center items-center gap-[8px] ${header_font_type}`}>
                                        <div className={`menu-link__link`}>{text.text}</div>
                                        {text.icon && <i className={`menu-link__icon icon ${text.icon} no-underline`}></i> }
                                    </span>
                                </a>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
};
